import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsReportComponent } from './transport-interventions-report.component';
import {DxLoadPanelModule, DxPopupModule, DxTabsModule} from 'devextreme-angular';
import {TransportInterventionsTimelineModule} from '../transport-interventions-timeline/transport-interventions-timeline.module';
import {TransportInterventionsMetricsModule} from '../transport-interventions-metrics/transport-interventions-metrics.module';
import {TransportInterventionMapModule} from '../transport-intervention-map/transport-intervention-map.module';


@NgModule({
  declarations: [TransportInterventionsReportComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxTabsModule,
    DxLoadPanelModule,
    TransportInterventionsTimelineModule,
    TransportInterventionsMetricsModule,
    TransportInterventionMapModule
  ],
  exports: [TransportInterventionsReportComponent]
})
export class TransportInterventionsReportModule { }
